import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseTrolley: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 3C1.25 2.58579 1.58579 2.25 2 2.25H4C4.9665 2.25 5.75 3.0335 5.75 4V14C5.75 14.1381 5.86193 14.25 6 14.25H21C21.4142 14.25 21.75 14.5858 21.75 15C21.75 15.4142 21.4142 15.75 21 15.75H6C5.0335 15.75 4.25 14.9665 4.25 14V4C4.25 3.86193 4.13807 3.75 4 3.75H2C1.58579 3.75 1.25 3.41421 1.25 3ZM18.5 13V7C18.5 6.17157 17.8284 5.5 17 5.5H9C8.17157 5.5 7.5 6.17157 7.5 7V13H9V7H17V13H18.5ZM9.5 19C9.5 20.3807 8.38071 21.5 7 21.5C5.61929 21.5 4.5 20.3807 4.5 19C4.5 17.6193 5.61929 16.5 7 16.5C8.38071 16.5 9.5 17.6193 9.5 19ZM7 20C7.55228 20 8 19.5523 8 19C8 18.4477 7.55228 18 7 18C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20ZM21.5 19C21.5 20.3807 20.3807 21.5 19 21.5C17.6193 21.5 16.5 20.3807 16.5 19C16.5 17.6193 17.6193 16.5 19 16.5C20.3807 16.5 21.5 17.6193 21.5 19ZM19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z"
        fill={color}
      />
    </svg>
  );
};
